import {popupCarousel} from "../../library/popup-carousel";
import {trackEvent} from "../../library/analytics";

$(document).ready(function() {
    let updateAJAX;
    $('.view-image').click(function(e) {
        e.preventDefault();
        trackEvent('TenQuality', 'ViewImage', 'click');
        let id = $(this).data('id');
        let imageNumber = $(this).data('num');

        if (typeof updateAJAX == 'object') {
            updateAJAX.abort();
        }
        updateAJAX = $.post(
            '/ajax/tenQuality/get-review-images',
            {
                id: id,
                imageNumber: imageNumber
            },
            function(data){
                if(data.done){
                    popupCarousel(data.carousel, data.numImages);
                }
            },
            'json'
        );
    });
});